module.exports = ":host /deep/ #auhen-container {\n  background-color: #0d5bd9; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authen/_views/authen.component.scss
// module id = ./src/app/authen/_views/authen.component.scss
// module chunks = main